import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { ReportContextMenu } from '../ReportContextMenu';
import { HiddenSectionDialog } from '../HiddenSectionDialog';
import { BirdActionMenu } from '../BirdActionMenu';
import { ReportContextMenuState } from '../../store/reportContextMenu/ReportContextMenuState';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ReportSection } from '../ReportSection';
import { useContextMenuHandlers } from '../hooks';
import { ExplanationInfoDialog } from '../ExplanationInfoDialog';
import { ManageColumnsDialog } from '../ManageColumnsDialog';
//css
import cn from './ReportContainer.css.json';
import './ReportContainer.css';
export const ReportPageContainerBase = ({ onPageLoad, state, contextMenuActions, }) => {
    const [hasOnLoadFired, setHasOnLoadFired] = useState(false);
    useEffect(() => {
        if (!hasOnLoadFired && onPageLoad && state.sectionData) {
            onPageLoad();
            setHasOnLoadFired(true);
        }
    }, [hasOnLoadFired, onPageLoad, state.sectionData]);
    const { onContextMenu, onKeyDown } = useContextMenuHandlers(contextMenuActions.open);
    if (!state.sectionData) {
        return null;
    }
    else {
        return (_jsx("div", Object.assign({ className: cn.reportContainerWrapper }, { children: _jsxs("div", Object.assign({ className: cn.reportContainerInner, onContextMenu: onContextMenu, onKeyDown: onKeyDown }, { children: [_jsx(ReportSection, { data: state.sectionData }), _jsx(ReportContextMenu, {}), _jsx(HiddenSectionDialog, { onContextMenu: onContextMenu }), _jsx(BirdActionMenu, {}), _jsx(ExplanationInfoDialog, {}), _jsx(ManageColumnsDialog, {})] })) })));
    }
};
export const ReportPageContainer = connect((state) => {
    const currentSection = state.sections.currentSection;
    return {
        state: {
            sectionData: (currentSection && state.sections.byId[currentSection]) || undefined,
        },
    };
}, (dispatch) => ({
    contextMenuActions: bindActionCreators(ReportContextMenuState.actions, dispatch),
}))(ReportPageContainerBase);
